module.exports = __webpack_public_path__ + "img/champion.0f54c23b.png";